var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("正在建设中……")])
}
var staticRenderFns = []

export { render, staticRenderFns }